import styled from '../../theme/styled-with-theme';
import { mediaQueries } from '../../styles/media-queries';
import { pxToRem } from '../../styles/utils';

import { Flexbox } from '../Flexbox';

export const LoaderWrapper = styled(Flexbox)`
  height: 100vh;
  width: 100vw;
  justify-content: center;
  align-items: center;
  background: linear-gradient(180deg, #00d9b4 0%, #99e4d7 100%);
`;

export const ImageWrapper = styled('div')`
  max-height: ${pxToRem(45)};
  max-width: ${pxToRem(250)};

  ${mediaQueries.desktop} {
    max-height: ${pxToRem(50)};
    max-width: ${pxToRem(325)};
  }
`;

export const BlockLoaderWrapper = styled('div')`
  height: ${pxToRem(38)};
  width: ${pxToRem(58)};
  margin-top: ${({ theme }) => theme.spacing.blockPadding_tablet};

  ${mediaQueries.desktop} {
    height: ${pxToRem(68)};
    width: ${pxToRem(88)};
  }
`;
